module.exports = {"370214001":"城阳街道","370214002":"夏庄街道","370214003":"流亭街道","370214004":"棘洪滩街道","370214005":"上马街道","370214008":"惜福镇街道","370214009":"红岛街道","370214010":"河套街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370214.json
// module id = 1486
// module chunks = 0